import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {SVGIcon} from '@homeaway/react-svg';
import {MAIL__24} from '@homeaway/svg-defs';

function Inbox({cssClass, text}) {
    const className = classNames('site-header-nav__inbox', {
        [`${cssClass}`]: !!cssClass
    });

    return (
        <div className={className}>
            <SVGIcon inlineFlex markup={MAIL__24} />
            <span className="site-header-nav__icon-label">{text}</span>
        </div>
    );
}

Inbox.propTypes = {
    cssClass: PropTypes.string,
    text: PropTypes.string.isRequired
};

export {Inbox};